/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {TimeBasedItemName, TimeBasedItemType} from "@shared/DueDatedItem/TimeBasedItemEnums";
import DbBaseObject from "@shared/DbBaseObject";

export default class TimeBasedItem extends DbBaseObject{


	title: string = ""
	dueDateTs: number = 0
	isCompleted: boolean = false
	dateCompletedTs: number = 0
	parentId: string = ""
	parentSecondaryId: string = ""
	parentType: TimeBasedItemType = ""

	constructor() {
		super();
	}



}



